import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useUser } from '../../../contexts/UserContext';
import { formatDateTimeUTC } from '../../../utils/timeUtils';
import Text from '../../elements/text/Text';
import UserTooltip from '../../elements/user-tooltip/UserTooltip';

const CreationMetadata = ({ author, createDate }) => {
  const { t } = useTranslation(0);
  const { user } = useUser();

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2 }}>
      <UserTooltip user={author}>
        <Text
          caption
          aria-label="createdBy"
          color="textSecondary"
          sx={{ cursor: 'pointer' }}
        >
          {t('creator', { ns: 'instance' })}: {author.publicName}
        </Text>
      </UserTooltip>
      <Text caption color="textSecondary">
        {t('createdAt', {
          ns: 'instance',
          date: formatDateTimeUTC(createDate, user?.timeZone),
        })}
      </Text>
    </Box>
  );
};

CreationMetadata.propTypes = {
  author: PropTypes.object.isRequired,
  createDate: PropTypes.string.isRequired,
};

export default CreationMetadata;
